import { render, staticRenderFns } from "./IconSvgCovid.vue?vue&type=template&id=a5ab3fe4&scoped=true&"
import script from "./IconSvgCovid.vue?vue&type=script&lang=js&"
export * from "./IconSvgCovid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ab3fe4",
  null
  
)

export default component.exports